import { Action } from 'redux';

export enum TUser {
  LOGIN = 'LOGIN',
  LOGINDESKTOP = 'LOGINDESKTOP',
  LOGOUT = 'LOGOUT',
  REFRESH = 'REFRESH',
  LOGIN_FAILED = 'LOGIN_FAILED',
  SET_LOGIN = 'SET_LOGIN',
  SET_MESSAGE = 'SET_MESSAGE',
}

interface User {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface ILogin extends Action {
  type: TUser.LOGIN;
  payload: User;
}

export interface ILoginDesktop extends Action {
  type: TUser.LOGINDESKTOP;
  payload: {bid: string};
}

export interface ILoginFailed extends Action {
  type: TUser.LOGIN_FAILED;
  payload: string;
}

export const ALoginFailed = (payload: string ): ILoginFailed => ({ type: TUser.LOGIN_FAILED, payload });

export const ALogin = (payload: User): ILogin => ({ type: TUser.LOGIN, payload });

export const ALoginDesktop = (payload: {bid: string}): ILoginDesktop => ({ type: TUser.LOGINDESKTOP, payload });

export interface ILogout extends Action {
  type: TUser.LOGOUT;
}
export const ALogout = (): ILogout => ({ type: TUser.LOGOUT });

export interface IRefresh extends Action {
  type: TUser.REFRESH;
}
export const ARefresh = (): IRefresh => ({ type: TUser.REFRESH });

export interface ISetLogin extends Action {
  type: TUser.SET_LOGIN;
}
export const ASetLogin = (): ISetLogin => ({ type: TUser.SET_LOGIN });

export interface ISetMessage extends Action {
  type: TUser.SET_MESSAGE;
  payload: string;
}
export const ASetMessage = (payload: string): ISetMessage => ({ type: TUser.SET_MESSAGE, payload });
